import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
} from "reactstrap";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { ToastContainer } from "react-toastify";
import withRouter from "../../components/Common/withRouter";
import Spinners from "../../components/Common/Spinner";
import VerticalLayout from "../../components/VerticalLayout";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import JsonPreview from "../AdminAppointmentDetails/components/jsonPreview";
import { getApiLogs } from "../../axios/apiLogs";

const ApiLogs = () => {
  document.title = "Api Logs | Seamless Slot";

  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // search state
  const [searchQuery, setSearchQuery] = useState("");

  const ContactsProperties = createSelector(
    (state) => state.contacts,
    (Contacts) => ({
      users: Contacts?.users,
      loading: Contacts?.loading,
    })
  );
  const { loading } = useSelector(ContactsProperties);

  const toggleModal = () => {
    setSelectedLog(null);
    setModal(false);
  };

  const formatTimestamp = (raw) => {
    const date = new Date(parseInt(raw) / 1_000_000);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");

    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${formattedHours}:${formattedMinutes} ${ampm} - ${day} ${month}, ${year}`;
  };

  const fetchLogs = async () => {
    setLoading(true);
    let response = await getApiLogs();
    const logs = response?.data?.data?.data.result?.flatMap((res) =>
      res.values.map(([timestamp, raw]) => {
        const parsed = JSON.parse(raw);
        return {
          timestamp,
          ...parsed,
          service_name: res.stream.service_name,
          formattedTimestamp: formatTimestamp(timestamp).toLowerCase(), // 👈 pre-compute once
        };
      })
    );

    setData(logs || []);
   // setTimeout(() => {
      setLoading(false);
   // }, 200);
  };

  // fetch once on mount
  useEffect(() => {
    fetchLogs();
  }, []);

  // update total pages when data or pageSize changes
  useEffect(() => {
    setTotalPages(Math.ceil((filteredData.length || 0) / pageSize));
  }, [data, pageSize, searchQuery]);

  // reset to first page when pageSize changes
  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, searchQuery]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // filter data by search
 // filter data by search (including formatted timestamp)
const filteredData = data.filter((log) => {
//  const formattedTime = formatTimestamp(log?.timestamp).toLowerCase();
  return (
    log?.message?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    log?.level?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    log?.service_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    log?.formattedTimestamp?.includes(searchQuery.toLowerCase()) // 👈 fast lookup
  //  formattedTime.includes(searchQuery.toLowerCase())
  );
});


  // pagination slice
  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // pagination renderer
  const renderPagination = () => {
    const pages = [];

    if (totalPages <= 1) return null;

    // Prev
    pages.push(
      <PaginationItem key="prev" disabled={currentPage === 1}>
        <PaginationLink onClick={() => handlePageChange(currentPage - 1)}>
        <i className="mdi mdi-chevron-left"></i>
        </PaginationLink>
      </PaginationItem>
    );

    // First page
    pages.push(
      <PaginationItem key={1} active={currentPage === 1}>
        <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
      </PaginationItem>
    );

    let start = Math.max(2, currentPage - 2);
    let end = Math.min(totalPages - 1, currentPage + 2);

    if (start > 2) {
      pages.push(
        <PaginationItem key="dots-left" disabled>
          <PaginationLink>...</PaginationLink>
        </PaginationItem>
      );
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <PaginationItem key={i} active={currentPage === i}>
          <PaginationLink onClick={() => handlePageChange(i)}>{i}</PaginationLink>
        </PaginationItem>
      );
    }

    if (end < totalPages - 1) {
      pages.push(
        <PaginationItem key="dots-right" disabled>
          <PaginationLink>...</PaginationLink>
        </PaginationItem>
      );
    }

    // Last page
    if (totalPages > 1) {
      pages.push(
        <PaginationItem key={totalPages} active={currentPage === totalPages}>
          <PaginationLink onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );
    }

    // Next
    pages.push(
      <PaginationItem key="next" disabled={currentPage === totalPages}>
        <PaginationLink onClick={() => handlePageChange(currentPage + 1)}>
        <i className="mdi mdi-chevron-right"></i>
        </PaginationLink>
      </PaginationItem>
    );

    return <Pagination>{pages}</Pagination>;
  };

  return (
    <VerticalLayout>
      <div className="page-content">
        {loading ? (
          <Spinners setLoading={setLoading} />
        ) : (
          <>
            <Container fluid>
              {/* <Breadcrumbs title="API Logs" breadcrumbItem="API Logs" /> */}
              <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                {/* Left side */}
                <p style={{ fontSize: '16px', fontWeight: 500, color: '#000', margin: 0 }}>
                API Logs
                </p>

                {/* Right side */}
                <div className="d-flex align-items-center gap-3">
            
     
          
      
        
               
                </div>
              </div>
              {isLoading ? (
                <Spinners setLoading={setLoading} timerStop={true} />
              ) : (
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        {/* search + page size */}
                        <div className="d-flex justify-content-end align-items-center mb-3">
                          
                          <div>
                            <Input
                              type="text"
                              placeholder="Search logs..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              style={{ maxWidth: "250px" }}
                            />
                          </div>
                        </div>

                        <div className="table-responsive">
                          <Table className="table table-hover table-bordered">
                            <thead>
                              <tr>
                                <th style={{ width: "20%" }}>Timestamp</th>
                                <th>Level</th>
                                <th>Message</th>
                                <th style={{  textAlign:'end'}}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedData.length > 0 ? (
                                paginatedData.map((log, idx) => (
                                  <tr key={idx}>
                                    <td>{formatTimestamp(log?.timestamp)}</td>
                                    <td>{log?.level}</td>
                                    <td>
                                      {log.message?.length > 150
                                        ? log.message.substring(0, 150) + "..."
                                        : log.message}
                                    </td>
                                    <td style={{
                                        cursor: "pointer",
                                        fontSize: "13px",
                                       textDecorationLine:'underline',
                                        textAlign:'end'
                                      }}onClick={() => {
    
                                        setSelectedLog(log);
                                        setModal(true);
                                      }}>View</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No logs found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <select
                              className="form-select"
                              style={{ width: "120px" }}
                              value={pageSize}
                              onChange={(e) => setPageSize(Number(e.target.value))}
                            >
                              <option value={10}>10 rows</option>
                              <option value={25}>25 rows</option>
                              <option value={50}>50 rows</option>
                            </select>
                          </div>
                          {renderPagination()}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </Container>
            <ToastContainer />
          </>
        )}
      </div>

      {/* Modal */}
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        style={{ width: 800, margin: "0px auto" }}
        centered
      >
        <ModalHeader toggle={toggleModal} tag="h4">
          API Log Details
        </ModalHeader>
        <ModalBody>
          <JsonPreview data={selectedLog} />
        </ModalBody>
      </Modal>
    </VerticalLayout>
  );
};

export default withRouter(ApiLogs);
